import React, { useState } from 'react';
import { fetchApiData } from '../../Utils/ApiCalls';
import { ATTACH_PLAN_ENDPOINT } from '../../urls';
import useFormStatus from '../../Hooks/useFormStatus';
import { Alert } from '../Alert';
import { Button, Input } from '@attentive-platform/stem-ui';
import { FormContainer } from '../../styled';

const ProConversionForm = () => {
  const [email, setEmail] = useState('');

  const { successMessage, errorMessage, handleApiResult } = useFormStatus();

  const handleSubmit = async e => {
    e.preventDefault();

    // Create an object with the form data
    const formData = {
      email: email.toLowerCase()
    };
    // Make the POST request to the API with the form data
    const response = await fetchApiData({
      endpoint: ATTACH_PLAN_ENDPOINT,
      data: formData
    });

    handleApiResult(response);
    setEmail('');
  };

  return (
    <form onSubmit={handleSubmit}>
      <Alert errorMessage={errorMessage} successMessage={successMessage} />
      <FormContainer>
          <Input
            label='Email'
            type='email'
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder='Enter email address'
            fullWidth
            required
          />
        <div className='flex justify-end'>
          <Button color='primary' size='medium' variant='contained' type='submit' className='text-base'>
            Add to PRO plan
          </Button>
        </div>
      </FormContainer>
    </form>
  );
};
export default ProConversionForm;
